export const FORM_SELECT_TYPES = {
  BREED: 'BREED',
  REPETITION: 'REPETITION'
} as const;

export const FORM_SELECT_COMPONENT_TYPES = {
  BREED: {
    title: `What’s {{petName}}'s Breed?`,
    registerAs: 'breed'
  },
  REPETITION: {
    title: 'How long would you like to repeat your booking for?',
    registerAs: 'repetition'
  }
} as const;
